import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import BrowseButton from 'Components/Utility/BrowseButton';
import categoryData from 'Components/QuickLinks/CategoryData';
import store from 'Redux/store';

const GenreLinks = ({ headingTag, intl: { formatMessage } }) => {
  const onClick = (to) => {
    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: 'BrowseByGenre', value: to },
    });
  };

  const HeadingTag = headingTag;

  return (
    <section className="quick-links">
      <div className="section-heading-container">
        <HeadingTag className="section-title">
          <FormattedMessage id="browsebygenre.browse" defaultMessage="Browse By Genre" />
        </HeadingTag>
        <BrowseButton className={'view-all-btn'} location={'categories'} />
      </div>
      <div className="quicklinks-container">
        {categoryData.map((category, i) =>
          <div
            key={category.to}
            className={classNames('quick-link',
              {
                'extra-quick-link': (i > 14 && i < 29),
                'last-two-quick-link': (i === 27 || i === 28),
              },
            )}
          >
            <Link to={category.to} onClick={() => onClick(category.to)}>
              {formatMessage(category.name)}
            </Link>
          </div>,
        )}

      </div>
    </section>

  );
};


GenreLinks.propTypes = {
  headingTag: PropTypes.string,
};

GenreLinks.defaultProps = {
  headingTag: 'h2',
};

export default injectIntl(GenreLinks);
